<div class="dropdown" [ngClass]="{
  'not-allowed': prohibited
}" #dropdownContainer>
  <div [class]="styleClass" [ngClass]="{
      'dropdown-wrapper': true,
      'inline-dropdown': isInline || theme=== 'inline',
      'active': isDropdownExpanded,
      'inline-bb': theme === 'inline-border-bottom',
      'dropdown-primary': theme === 'primary',
      'dropdown-secondary': theme === 'secondary',
      'dropdown-light': theme === 'light',
      'dropdown-border': theme === 'border',
      'isFloating': renderValue(),
      'not-allowed': prohibited
    }">
    <input type="text" class="hidden-input" autocomplete="off" autocorrect="off" spellcheck="false"
      name="{{name}}-hidden" (focus)="autoFocus ? onFocus() : ''" (click)="onFocus()" (keydown.esc)="onDropdownClick()" (keydown.tab)="onTabPress()"
      (keydown.shift.tab)="onTabPress(); onShiftTabPress();" (keydown.arrowdown)="onSelectOption('down')"
      (keydown.arrowup)="onSelectOption('up')" (keydown.enter)="onEnter($event)" #dropdownInput>
    <!-- Start Input -->
    <div id="d-open-{{id}}" [hidden]="showIconToOpen || hasCustomOpenTemplate" (click)="onDropdownClick()"
      [class]="styleClassSelectedView" [ngClass]="{
          'selected-view': true,
          'active': isDropdownExpanded,
          'pointer flex-start-center': true,
          'disabled': disabled,
          'invalid': hasError,
          'hover-effect': hasHoverEffect,
          'active-bg': hasBgOnActive,
          'float-label': renderValue(),
          'dropdown-icon-left': leftIcon,
          'dropdown-icon-right': rightIcon,
          'no-border-bottom': !hasBorderBottomOnActive
       }" #selectedView>
      <i [hidden]="!leftIcon" [class]="leftIcon" [ngClass]="{'left-icon icon': true}"></i>
      <div [class]="styleClassValue" [ngStyle]="{fontSize: fontSize + 'px'}"
        [ngClass]="{'placeholder': !renderValue(), 'selected-value width-100p ': true, 'disabled': disabled}">
        <div *ngIf="renderValue()" [class]="styleClassText" [ngClass]="{'text-truncate': truncateString}">
          <span [id]="id" [class]="'selected-value-span ' + styleClassText" (click)="onValueClick($event)">
            {{renderValue() }}
          </span>
        </div>
        <div [id]="'placeholder-' + id" [class]="'' + styleClassPlaceholder" *ngIf="!renderValue()"
          [ngClass]="{'opacity-0': floatingLabel, 'dropdown-placeholder': !floatingLabel}">{{placeholder}}</div>
      </div>
      <i *ngIf="isDropdownIconVisible && !isDropdownExpanded" class="icon fal fa-chevron-down font-12 text-right"></i>
      <i *ngIf="isDropdownIconVisible && isDropdownExpanded" class="icon fal fa-chevron-up font-12 text-right"></i>
      <label [hidden]="!floatingLabel" [class]="styleClassLabel"
        [ngClass]="{'disabled': disabled, 'app-input-label pointer': true, 'app-label-float': floatingLabel}">
        {{label || placeholder}}
      </label>
      <div [ngClass]="{'app-input-error': true}" [class]="styleClassError">
        {{errorMessage}}
      </div>
    </div>
    <!-- End Input -->

    <!-- Start Icon Dropdown -->
    <div [id]="'icon-' + id" [hidden]="!showIconToOpen" (click)="onDropdownClick()" [class]="styleClassSelectedView"
      [ngClass]="{
          'pointer p-1 text-left selected-view flex-start-center': true,
          'active': isDropdownExpanded,
          'icon-dropdown': showIconToOpen,
          'disabled': disabled
        }" #selectedView>
      <i [ngClass]="{'icon': true}" [class]="openDropdownIcon"></i>
    </div>
    <!-- End Icon Dropdown -->

    <!-- Start Custom Open Button -->
    <div [id]="'btn-' + id" [hidden]="!hasCustomOpenTemplate" (click)="onDropdownClick($event)"
      [class]="styleClassSelectedView" [ngClass]="{
          'pointer p-1 selected-view flex-start-center': true,
          'active': isDropdownExpanded,
          'icon-dropdown': hasCustomOpenTemplate,
          'disabled': disabled
        }" #selectedView>
      <ng-container *ngTemplateOutlet="openDropdownBtn">
      </ng-container>
      <i *ngIf="isDropdownIconVisible  && isCustomizedTemplate && !isDropdownExpanded"
        class="icon fal fa-chevron-down font-12 text-right"></i>
      <i *ngIf="isDropdownIconVisible && isCustomizedTemplate && isDropdownExpanded"
        class="icon fal fa-chevron-up font-12 text-right"></i>
    </div>
    <!-- End Custom Open Button -->

    <div [class]="styleClassDropdownList" [ngStyle]="{'min-width': itemWidth, 'margin-left': itemMargin}" [ngClass]=" {
        'dropdown-list-wrapper  width-100p': true,
        'show' : isDropdownExpanded,
        'icon-dropdown-list-wrapper': hasCustomItemTemplate,
        'has-create-field' : hasEditableField || autocompleteItemEditable,
        'top-list': position === 'top',
        'bottom-list': position === 'bottom',
        'left-list': hPosition === 'left'
        }" #dropdownListContainer>
      <div [hidden]="!hasListHeader" class="flex-between-center list-header">
        <span class="font-11" [ngClass]="{'font-10': fontSize === 10}"> {{listHeaderTitle}}</span>
        <i class="icon fal fa-times font-10 pointer" (click)="onDropdownClick()"></i>
      </div>

      <div class="pl-1 pr-1 pt-2 pb-2" *ngIf="searchFilter?.isSearchEnable">
        <app-input [placeholder]="searchFilter?.searchPlaceholder" [value]="query" styleClassInput="width-100p"
          theme="border" (appChange)="onSearch($event, searchFilter?.serachField || field)"
          [maxLength]="searchFilter?.maxLength || 1000">
        </app-input>
      </div>

      <ul [id]="listId" [ngClass]="{'icon-dropdown-list': hasCustomItemTemplate}" class="dropdown-list"
        [ngStyle]="{'max-height': scrollHeight }" #dropdownList>
        <li [ngStyle]="{'min-width': itemWidth }" [hidden]="!isLoading"
          [ngClass]="{'dropdown-list-item text-left': true}">
          <span class="pr-2">Loading</span> <i class="fal fa-spinner rotate"></i>
        </li>

        <span *ngIf="options?.length">
          <span *ngFor="let option of options; let i = index" [hidden]="isLoading"
            [ngClass]="{ 'not-allowed': option?.disabled }" [pTooltip]="option?.tooltip || ''" tooltipPosition="left">
            <li id="item-{{ id }}{{ i }}" class="{{ styleClassDropdownListItem }}item{{ i }}"
              [ngStyle]="{ 'min-width': itemWidth }" [hidden]="option?.hideItem" [ngClass]="{
                'dropdown-list-item text-left': true,
                'highlighted-item': selectedOptionIndex === i,
                active: (value && value[idKey]) === (option && option[idKey]) && focusOnSelectedValue,
                'option-disabled': option.disabled
              }" (click)="onSelect(option, $event)">
              <span *ngIf="!hasCustomItemTemplate" [ngStyle]="{ fontSize: fontSize + 'px' }" [ngClass]="{
                  'font-12': listItemFontSize === 12,
                  'font-14': listItemFontSize === 14,
                  'font-8': listItemFontSize === 8
                }">
                <img alt="{{ option?.altText }}" [ngStyle]="option?.imageStyle" [src]="option?.imageIcon"
                  *ngIf="showImage && option?.imageIcon" />
                {{ resolveFieldData(option) }}
              </span>

              <span *ngIf="hasCustomItemTemplate">
                <ng-container *ngTemplateOutlet="autocompleteItem; context: { $implicit: option, index: i }">
                </ng-container>
              </span>
            </li>
          </span>
        </span>

        <span *ngIf="showNoDataFound && !options?.length">
          <li class="p-2 no-data-found">{{noDataFoundMessage}}</li>
        </span>
      </ul>

      <div *ngIf="dropdownFooter || hasFooter" class="app-dropdown-footer">
        <ng-container *ngTemplateOutlet="dropdownFooter">
        </ng-container>
      </div>

      <div [ngStyle]="{'min-width': itemWidth }" *ngIf="autocompleteItemEditable || hasEditableField"
        class="auto-complete-list-static">

        <!-- Start Create Field Section -->
        <div [hidden]="!hasEditableField" class="auto-complete-item-create" #createField>
          <!-- Show if query length is less then 3 and editable mode is off -->
          <span class="highlighted-text pointer mb-2" [hidden]="query?.length >= 3 || isEditable"
            (click)="toggleEditMode()">
            {{ editFieldLabel }}
          </span>

          <!-- Show if query length is greater then 3 and editable mode is off -->
          <div [hidden]="isEditable || query?.length < 3" class="flex-between-center mb-2">
            <span class="query">{{query}}</span>
            <span class="highlighted-text pointer" (click)="toggleEditMode()">{{editFieldLabel}}</span>
          </div>

          <!-- Show if isEditable is true and query length is greater than 3 -->
          <div [hidden]="!isEditable" class="flex-between-center flex-wrap bg-body">
            <input *ngIf="editFieldMask" type="text" autocomplete="off" autocorrect="off" spellcheck="false"
              name="{{name}}-edit-1" [(ngModel)]="query" [mask]="allowDecimal ? '' : editFieldMask"
              [placeholder]="editFieldLabel" [maxlength]="editFieldMaxLength" class="create-field testing"
              (paste)="validatePaste($event)" (keypress)="onKeyPress($event)" #createInputField>

            <input *ngIf="!editFieldMask" type="text" autocomplete="off" autocorrect="off" spellcheck="false"
              name="{{name}}-edit-2" [placeholder]="editFieldLabel" [maxlength]="editFieldMaxLength"
              class="create-field testings" [(ngModel)]="query" (keyup)="onChangeType($event)" #createInputField>

            <div class="" [hidden]="!isShowError">
              <span class="font-12 font-error">Category name already exists</span>
            </div>

            <div class="add-field-action">
              <span class="float-right">
                <div [hidden]="!hasColorSelection" class="color-circle-wrapper">
                  <div *ngFor="let color of colors" class="color-circle" [ngStyle]="{'background-color': color.value}"
                    (click)="onColorSelect(color.value)" [ngClass]="{active: color.value === selectedColor}">
                  </div>
                </div>
                <button [disabled]="query?.length < minCreateStrLength || isShowError"
                  [ngClass]="{'disabled': query?.length < minCreateStrLength }" class="save btn-create"
                  (click)="onCreate()">
                  {{createButtonTitle}}
                </button>
              </span>
            </div>
          </div>
        </div>
        <!-- End Create Field Section -->

        <div *ngIf="autocompleteItemEditable"
          class="auto-complete-list-item auto-complete-list-item pointer bg-light-gray font-primary p-2"
          (click)="toggleEditMode()">
          <ng-container *ngTemplateOutlet="autocompleteItemEditable">
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
